import React, { FC, useState, useContext } from 'react'

import { CustomScoringTotal } from '../../../../../pages/organizer/manage/ManageClinicNOtherOperationsTab/components/CustomScoringTotal/CustomScoringTotal'
import { DefaultScoringTotal } from '../../../../../pages/organizer/manage/ManageClinicNOtherOperationsTab/components/DefaultScoringTotal/DefaultScoringTotal'
import { HorseTrainer } from '../../../../rider/HorseTrainer/HorseTrainer'
import { RankNumber } from '../../../../../pages/organizer/manage/components/RankNumber'

import { getIconColor } from '../../../../../helpers/getIconColor'
import { getFloatPrice } from '../../../../../helpers/price'
import {
  sortByTotalPoints,
  sortResultsByTime,
} from '../../../../../pages/organizer/manage/ManageClinicNOtherOperationsTab/data/operations-tab-utils'
import {
  IEventTeamMemberInterface,
  useEventRiderTeamMembers,
} from '../../../../../hooks/useEventRiderTeamMembers'

import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'

import { HandleModalContext } from '../../../../../layout/mainlayout/MainLayout'
import { MODAL_CONSTS } from '../../../../../const/modal-const'
import { IMAGE_CONSTS } from '../../../../../const/image-const'
import { HORSE_NAME_DEFAULT } from '../../../../../models/registrations-by-day/registrationByDay.interface'

type ExhibitorResultsAccordionProps = {
  data: IRegistrationByDayInterface[]
  publishScore: boolean
  publishPrize: boolean
  prizeMoney: number
  isAsc: boolean
  eventId: string
  currency: string
}

interface DetailRowProps {
  color: string
  row: IRegistrationByDayInterface
  publishScore: boolean
  publishPrize: boolean
  prizeMoney: number
  eventTeamMembers: IEventTeamMemberInterface
  eventTeamMembersLoading: boolean
  index: number
  currency: string
}

const DetailRow: FC<DetailRowProps> = ({
  row,
  publishScore,
  publishPrize,
  prizeMoney,
  color,
  eventTeamMembers,
  eventTeamMembersLoading,
  index,
  currency,
}) => {
  const [errorImg, setErrorImg] = useState(false)

  const handleModalContext = useContext(HandleModalContext)

  const handleModalOpen = () => {
    if (row.score?.sheet?.type === 'hunter-jumper') {
      handleModalContext?.handleModal(true, MODAL_CONSTS.CUSTOM_SCORING, {
        modalTitle: 'Results',
        rider: row,
        prizeMoney: prizeMoney,
        publishPrize: publishPrize,
        editable: false,
      })
    } else {
      handleModalContext?.handleModal(true, MODAL_CONSTS.SCORING, {
        rider: row,
        prizeMoney: prizeMoney,
        publishPrize: publishPrize,
        editable: false,
      })
    }
  }

  const arrayName = row.riderName?.split(' ') || []

  const judge = row.score?.judges?.[0]

  return (
    <>
      <div className="flex flex-wrap items-center justify-between w-full my-2 gap-4 md:gap-2">
        <div className="w-full md:w-1/3 flex items-center">
          {row.riderProfilePicture && !errorImg ? (
            <img
              src={row.riderProfilePicture}
              onError={() => setErrorImg(true)}
              alt="avatar"
              className="w-[45px] h-[45px] rounded-full mt-1 object-cover"
            />
          ) : (
            <div
              style={{ background: color }}
              className={`w-[45px] h-[45px] rounded-full mt-1 flex items-center justify-center text-white`}
            >
              {arrayName[0][0]}
              {arrayName.length > 1 ? arrayName[arrayName.length - 1][0] : ''}
            </div>
          )}
          <div className="ml-3">
            <div className="text-SeabiscuitDark200ThemeColor font-bold text-base">
              {row.riderName}
            </div>
            <span className="text-base text-SeabiscuitDark200ThemeColor/50">
              {row.backNumber ? `Back number • ${row.backNumber}` : null}
            </span>
          </div>
        </div>
        <div className="w-full md:w-1/3 flex items-center">
          <img
            src={row.horseProfilePicture ? row.horseProfilePicture : IMAGE_CONSTS.PLACEHOLDERS.USER}
            alt="avatar"
            className="w-[45px] h-[45px] rounded-full mt-1 object-cover"
          />
          <div className="ml-3 text-base">
            <div className="text-SeabiscuitDark200ThemeColor font-bold">
              {row.horseName ?? HORSE_NAME_DEFAULT}
            </div>
            <div className="text-SeabiscuitDark200ThemeColor/50">
              <HorseTrainer
                title="Trainer"
                eventTeamMembers={eventTeamMembers}
                eventTeamMembersLoading={eventTeamMembersLoading}
                rider={row}
              />
            </div>
          </div>
        </div>
        {publishScore ? (
          row.score?.sheet?.type === 'hunter-jumper' && judge ? (
            <div
              className="flex items-center md:ml-auto md:text-right gap-2.5 transition-all cursor-pointer hover:opacity-70"
              onClick={handleModalOpen}
            >
              <CustomScoringTotal row={row} />
              <RankNumber
                rank={
                  row.isScratched || row.score?.scoreStatus
                    ? null
                    : Number(row.score?.rank) || index + 1
                }
              />
            </div>
          ) : Number(row.score?.totalPoints) ? (
            <div className="md:ml-auto flex gap-2.5 justify-center items-center">
              <div className="md:text-right">
                <div className="flex gap-2 justify-end">
                  {row.isQualify && <span className={'font-semibold '}>Q •</span>}
                  <DefaultScoringTotal row={row} />
                </div>
                {publishPrize ? (
                  <div className="opacity-50 cursor-pointer text-[14px]" onClick={handleModalOpen}>
                    {prizeMoney && row.score?.earning ? (
                      <span className="underline">
                        {getFloatPrice(
                          `${currency}${(Number(prizeMoney || 0) * Number(row.score.earning)) / 100}`
                        )}
                      </span>
                    ) : (
                      <span className="underline text-SeabiscuitDark200ThemeColor/50">
                        {currency}0
                      </span>
                    )}
                  </div>
                ) : (
                  <div
                    className="opacity-50 underline cursor-pointer text-[14px]"
                    onClick={handleModalOpen}
                  >
                    More
                  </div>
                )}
              </div>
              <RankNumber
                rank={
                  row.isScratched || row.score?.scoreStatus
                    ? null
                    : Number(row.score?.rank) || index + 1
                }
              />
            </div>
          ) : (
            <div className="md:ml-auto flex gap-2.5 justify-center items-center">
              <div className="md:ml-auto md:text-right">
                <div className="font-bold text-SeabiscuitDark200ThemeColor">0</div>
                <div className="opacity-50 text-[14px]">
                  {row.score?.scoreStatus || 'Not yet scored'}
                </div>
              </div>
              <RankNumber rank={null} />
            </div>
          )
        ) : (
          <div className="ml-auto">
            <div className="md:text-right text-SeabiscuitDark200ThemeColor">Results</div>
            <div className="md:text-right text-[14px] text-SeabiscuitDark200ThemeColor/50">
              Not yet published
            </div>
          </div>
        )}
      </div>
      <hr></hr>
    </>
  )
}

const ExhibitorResultsAccordion: FC<ExhibitorResultsAccordionProps> = ({
  data,
  publishScore,
  publishPrize,
  prizeMoney,
  isAsc,
  eventId,
  currency,
}) => {
  const { eventTeamMembers, eventTeamMembersLoading } = useEventRiderTeamMembers(eventId)
  let sorted
  const scoreCardType = data?.[0]?.score?.judges?.[0]?.scoreCardType
  if (scoreCardType === 'fastest') {
    sorted = sortResultsByTime(data, isAsc ? 'asc' : 'desc', 'fastest')
  } else if (scoreCardType === 'optimum') {
    sorted = sortResultsByTime(data, isAsc ? 'asc' : 'desc', 'optimal')
  } else {
    sorted = sortByTotalPoints(data, isAsc ? 'asc' : 'desc')
  }

  return (
    <>
      {data?.length > 0 &&
        sorted.map((currentItem, index) => {
          return (
            <DetailRow
              index={index}
              eventTeamMembers={eventTeamMembers}
              eventTeamMembersLoading={eventTeamMembersLoading}
              key={`${JSON.stringify(currentItem)}${index}`}
              row={currentItem}
              publishScore={publishScore}
              publishPrize={publishPrize}
              prizeMoney={prizeMoney}
              color={getIconColor(data.length, index)}
              currency={currency}
            />
          )
        })}
    </>
  )
}

export default ExhibitorResultsAccordion
